











 

















const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreatePollMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Poll",
      "kind": "LinkedField",
      "name": "poll",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ThreadedItem_threadable"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discussionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "threadSortOrder",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PollOption",
          "kind": "LinkedField",
          "name": "options",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CreatePollSuccess",
  "abstractKey": null
};
})();

(node ).hash = "5689641f1c9fa82babf152699f088e4e";

export default node;
